<template>
  <router-view/>
</template>

<style>
@import '~@vueform/slider/themes/default.css';
@import '~vue-next-select/dist/index.min.css';
</style>